import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "form",
  style: {"text-align":"justify"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, " Cancellando questo account verranno rimossi tutti i riferimenti alla sua persona. "),
  /*#__PURE__*/_createElementVNode("p", null, " Se ha acconsentito alla conservazione dei dati personali dopo la cancellazione del proprio account, le informazioni, pseudonomizzate*, saranno conservate per un periodo di un un anno a partire dalla data di avvenuta cancellazione. "),
  /*#__PURE__*/_createElementVNode("p", null, " *Le informazioni di profilazione sono conservate in una forma che impedisce l'identificazione dell'utente. ")
], -1)
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "flex flex-col items-center justify-center h-screen mt-4" }
const _hoisted_5 = {
  class: "account",
  href: "https://www.micurobene.it/password/reset"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Sottoscrizioni ", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " Accessi ", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Consensi ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " Cookies ", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, " Elimina Account ", -1)
const _hoisted_15 = [
  _hoisted_14
]

import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import router from '@/router';
import { ref } from 'vue';
import { Modal } from "flowbite-vue";
import { destroyUser } from "@/../../EshJSLib/services/userServices";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountPage',
  setup(__props) {

const store = patientStore();
const { patient } = storeToRefs(store);
const isShowModal = ref(false);

function openRoute (route: string){
    router.push(route);
}

function openSite(url) {
    window.open(url, '_blank');
}

function closeModal() {
    isShowModal.value = false;
}

function deleteAccount() {
    destroyUser();
}

return (_ctx: any,_cache: any) => {
  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (isShowModal.value)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 0,
              size: "2xl",
              onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal()))
            }, {
              header: _withCtx(() => [
                _createTextVNode(" Elimina Account ")
              ]),
              body: _withCtx(() => [
                _hoisted_2
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: closeModal,
                    type: "button",
                    class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  }, _toDisplayString(_ctx.$t("Annulla")), 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteAccount())),
                    class: "text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                  }, _toDisplayString(_ctx.$t("Prosegui")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t("Cambia Password")), 1),
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = () => openRoute('/Registro/Paypal')),
            class: "account"
          }, _hoisted_7),
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = () => openRoute('/Registro/Accessi')),
            class: "account"
          }, _hoisted_9),
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = () => openRoute('/account/Consensi')),
            class: "account"
          }, _hoisted_11),
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (openSite('https://www.micurobene.it/cookie-page'))),
            class: "account"
          }, _hoisted_13),
          _createElementVNode("div", {
            class: "account",
            onClick: _cache[6] || (_cache[6] = ($event: any) => {isShowModal.value = true;})
          }, _hoisted_15)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})